import React from 'react';

function ScorecardAttendance({ rollups }) {
  return (
    <div className="scorecard-section">
      <h2>Attendance Summary</h2>
      <div className="attendance-summary-table">
        <div className="summary-item">
          <span className="label">At Work %:</span>
          <span className="value">{rollups.atWorkRate.toFixed(1)}%</span>
        </div>
        <div className="summary-item">
          <span className="label">Eligible Workdays:</span>
          <span className="value">{rollups.eligibleWorkdays} days</span>
        </div>
        <div className="summary-item">
          <span className="label">Planned Leave Days:</span>
          <span className="value">{rollups.plannedLeaveDays} days</span>
        </div>
        <div className="summary-item">
          <span className="label">Unplanned Absence Days:</span>
          <span className="value">{rollups.unplannedAbsenceDays} days</span>
        </div>
        <div className="summary-item">
          <span className="label">At Work Days:</span>
          <span className="value">{rollups.atWorkDays} days</span>
        </div>
        <div className="summary-item">
          <span className="label">Total Present:</span>
          <span className="value">{rollups.totalPresent} days</span>
        </div>
        <div className="summary-item">
          <span className="label">Total Absent:</span>
          <span className="value">{rollups.totalAbsent} days</span>
        </div>
        <div className="summary-item">
          <span className="label">Late Arrivals:</span>
          <span className="value">{rollups.totalLate} times</span>
        </div>
        <div className="summary-item">
          <span className="label">Sick Days:</span>
          <span className="value">{rollups.totalSick} days</span>
        </div>
        <div className="summary-item">
          <span className="label">Vacation Days:</span>
          <span className="value">{rollups.totalVacation} days</span>
        </div>
      </div>
    </div>
  );
}

export default ScorecardAttendance;
